function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#BFB7B6",
  fillRule: "evenodd",
  d: "M2 12.5v1.313c0 .112.075.187.188.187h11.624c.113 0 .188-.075.188-.188V12.5c0-1.575-1.204-2.85-2.742-3-.113 0-.218.077-.293.152C10.252 10.515 9.238 11 8 11c-1.237 0-2.252-.485-2.965-1.348-.075-.075-.18-.152-.293-.152C3.205 9.65 2 10.925 2 12.5zm3-6.75c0 2.063.713 4.125 3 4.125 2.213 0 3-2.063 3-4.125.713-2.212-.787-3-1.5-3C9.463 2.038 8.638 2 8 2 5.038 2 4.4 4.438 5 5.75z"
});
function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref);
}
export default SvgPerson;